import React from 'react';

import './TemplateSelector.css';

const templates = [
  {
    name: 'Blog',
    filename: 'blog-example.zip',
    imgSrc: '/assets/img/blog-template.jpg'
  },
  {
    name: 'Agency',
    filename: 'agency-example.zip',
    imgSrc: '/assets/img/agency-template.jpg'
  },
  {
    name: 'Portfolio',
    filename: 'portfolio-example.zip',
    imgSrc: '/assets/img/portfolio-template.jpg'
  },
  {
    name: 'CV/Resume',
    filename: 'cv-example.zip',
    imgSrc: '/assets/img/cv-template.jpg'
  }
]

const TemplateSelector = ({onClick}) => {
  return <div className="template-selector-container pt-3 pb-5">
    {templates.map(({ name, filename, imgSrc }) =>
      <div
        className="template-selector-option p-2 round-8 cursor-pointer tr-template-option"
        key={filename}
        onClick={() => onClick({
          path: filename,
          type: 'application/zip',
          isTemplate: true
        })}
      >
      <img className="template-selector-option-img" src={imgSrc} height="130" width="130"/>
      <div className="mt-2 grey">{name}</div>
    </div>)}
  </div>
}

export default TemplateSelector;